import { ACTOR_ID_HEADER_KEY, PAYMENT_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

const CHARGES_BASE = `${PAYMENT_SERVICE_BASE_URL}/api/v1/payments/charges`;
const ORGANIZATION_OWNER_PARAM = `business${"Entity"}Id`;
const LEGACY_PAYER_ORGANIZATION_ID = `payerBusiness${"Entity"}Id`;
const LEGACY_PAYER_ORGANIZATION = `payerBusiness${"Entity"}`;
const LEGACY_DETAILS_PAYER_ORGANIZATION_ID = `payerBusiness${"Entity"}Id`;
const LEGACY_DETAILS_PAYER_ORGANIZATION = `payerBusiness${"Entity"}`;

const actorHeaders = (actorId) =>
  actorId ? { [ACTOR_ID_HEADER_KEY]: actorId } : {};

const withPaging = (params = {}) => {
  const { page = 0, size = 20, ...rest } = params;
  return { page, size, sort: "createdAt,desc", ...rest };
};

const pageContent = (data) => (Array.isArray(data) ? data : data?.content || []);

const chargeOrganizationId = (charge) =>
  charge?.payerOrganizationId ||
  charge?.payerOrganization?.id ||
  charge?.paymentChargeDetails?.payerOrganizationId ||
  charge?.paymentChargeDetails?.payerOrganization?.id ||
  charge?.[LEGACY_PAYER_ORGANIZATION_ID] ||
  charge?.[LEGACY_PAYER_ORGANIZATION]?.id ||
  charge?.paymentChargeDetails?.[LEGACY_DETAILS_PAYER_ORGANIZATION_ID] ||
  charge?.paymentChargeDetails?.[LEGACY_DETAILS_PAYER_ORGANIZATION]?.id ||
  null;

const chargeWorkspaceId = (charge) =>
  charge?.workspaceId ||
  charge?.paymentChargeDetails?.workspaceId ||
  null;

const withScopedContent = (result, { organizationId, workspaceId } = {}) => {
  const content = pageContent(result).filter((charge) => {
    const chargeEntityId = chargeOrganizationId(charge);
    const entityMatches = organizationId ? chargeEntityId === organizationId : !chargeEntityId;
    const chargeScopedWorkspaceId = chargeWorkspaceId(charge);
    const workspaceMatches = workspaceId ? !chargeScopedWorkspaceId || chargeScopedWorkspaceId === workspaceId : true;
    return entityMatches && workspaceMatches;
  });

  if (Array.isArray(result)) return content;
  return { ...result, content };
};

export const paymentChargesService = {
  outgoing: {
    listForUser: async ({ actorId, userId, organizationId, workspaceId, start, end, page = 0, size = 20 } = {}) => {
      const response = await apiClient.get(`${CHARGES_BASE}/user/range`, {
        params: withPaging({
          uid: userId || undefined,
          workspaceId: workspaceId || undefined,
          [ORGANIZATION_OWNER_PARAM]: organizationId || undefined,
          start,
          end,
          page,
          size,
        }),
        headers: actorHeaders(actorId),
      });
      return withScopedContent(response.data || { content: [] }, { organizationId, workspaceId });
    },
  },

  receivable: {
    listForOrganization: async ({
      actorId,
      userId,
      organizationId,
      workspaceId,
      start,
      end,
      page = 0,
      size = 20,
    } = {}) => {
      const response = await apiClient.get(`${CHARGES_BASE}/receivable/user/range`, {
        params: withPaging({
          uid: userId || actorId || undefined,
          workspaceId: workspaceId || undefined,
          [ORGANIZATION_OWNER_PARAM]: organizationId || undefined,
          start,
          end,
          page,
          size,
        }),
        headers: actorHeaders(actorId),
      });
      return response.data || { content: [] };
    },
  },
};

export default paymentChargesService;
